import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface ItemProps {
  $align?: 'center';
}

export const Item = styled.li.withConfig({ componentId: 'sc-15rb1rp-0' })<ItemProps>`
    display: flex;
    align-items: flex-start;

    ${({ $align }) =>
      $align === 'center'
        ? css`
                  justify-content: center;
              `
        : undefined}
`;

interface ListsProps {
  $spacing?: 'large' | 'small';
  $size?: 'small';
}

export const List = styled.ul.withConfig({ componentId: 'sc-15rb1rp-1' })<ListsProps>`
    --checklist-icon-size: ${(props) => props.theme.font.size.regular};
    --checklist-title-size: ${(props) => props.theme.font.size.regular};
    --checklist-line-height: ${(props) => props.theme.font.lineHeight.main};
    --checklist-icon-spacing: ${size(1.5)};

    list-style: none;
    padding: 0;
    margin: 0;

    ${({ $spacing }) =>
      $spacing === 'large'
        ? css`
                  ${Item} + ${Item} {
                      margin-top: ${size(3)};
                  }
              `
        : $spacing === 'small'
          ? css`
                  ${Item} + ${Item} {
                      margin-top: ${size(0.5)};
                  }
              `
          : css`
                  ${Item} + ${Item} {
                      margin-top: ${size(1)};
                  }
              `}

    ${({ $size }) =>
      $size === 'small'
        ? css`
                  --checklist-icon-size: ${(props) => props.theme.font.size.small};
                  --checklist-title-size: ${(props) => props.theme.font.size.small};
                  --checklist-icon-spacing: ${size(1)};
              `
        : undefined}
`;

interface IconProps {
  $tone?: 'error';
}

export const Icon = styled.div.withConfig({ componentId: 'sc-15rb1rp-2' })<IconProps>`
    flex-shrink: 0;
    padding-right: var(--checklist-icon-spacing);
    color: var(--c-semantic-success-500);
    font-size: var(--checklist-icon-size);
    margin-top: calc((var(--checklist-icon-size) - var(--checklist-title-size) * var(--checklist-line-height)) / -2);

    ${({ $tone }) =>
      $tone === 'error'
        ? css`
                  color: var(--c-semantic-error-500);
              `
        : undefined}
`;

export const Title = styled.div.withConfig({ componentId: 'sc-15rb1rp-3' })`
    font-size: var(--checklist-title-size);
    line-height: var(--checklist-line-height);
`;
